import { setupRem } from '@/utils/useRem'
import { createApp } from 'vue'
import '@/style.css'
import App from '@/App.vue'
import router from '@/router/index.js'
import telegramPlugin from '@/plugins/telegram.js'
import i18n from '@/plugins/i18n.js'

// Extra guard for Telegram WebView clients that emit events before sdk init.
if (typeof window !== 'undefined') {
  window.TelegramGameProxy = window.TelegramGameProxy || {}
  if (typeof window.TelegramGameProxy.receiveEvent !== 'function') {
    window.TelegramGameProxy.receiveEvent = function () {}
  }
}

setupRem()

const app = createApp(App)
app.use(telegramPlugin)
app.use(router)
app.use(i18n)

app.config.globalProperties.$baseUrl = import.meta.env.BASE_URL

app.config.errorHandler = (err, instance, info) => {
    console.error('[Vue Error]', err)
    const tg = app._context.provides.telegram
    if (tg && tg.log) {
        tg.log(`VUE-ERR: ${err.message}`)
    }
}

window.onerror = (msg, url, lineNo, columnNo, error) => {
    console.error('[Window Error]', msg)
    const tg = app._context.provides.telegram
    if (tg && tg.log) {
        tg.log(`WIN-ERR: ${msg}`)
    }
    return false
}

app.mount('#app')
